import React from "react";
import { LeadAssignmentRulesFilterProps } from "../lead-assignment-props";
import { SearchInputComponent } from "../../../../common/components";
import FilterIcon from "../../../../assets/icons/filter-icon.svg";
import ArchiveIcon from "../../../../assets/icons/archive-icon.svg";
import { Stack, Badge } from "@mui/material";
import { Link } from "react-router-dom";
import { routes } from "../../../../constants/routes";
import { useCheckIsAFPSuperAdmin } from "../../../../utils/checkIsAFPSuperAdmin";
import MODULES from "../../../../constants/modules";
import { useResourcePermissions } from "../../../../common/hooks/resource-permissions";
import CustomTooltip from "../../../../common/components/custom-tooltip";
import RefreshIcon from '@mui/icons-material/Refresh';

const LeadAssignmentRulesFilters: React.FC<LeadAssignmentRulesFilterProps> = ({
  isOpenFilter,
  setIsOpenFilter,
  onSearch,
  selectedLeadsFilter,
  totalDeletedRules,
  searchRef,
  fetchRules
}) => {
  const isSuperAdmin = useCheckIsAFPSuperAdmin();
  const { canWrite } = useResourcePermissions(MODULES.LEAD_ASSIGNMENT);
  const handleRefresh = () => {
    fetchRules?.();
  };
  return (
    <>
      <div className="lead-assignment-rules-search-and-filters-wrapper">
        <div className="lead-assignment-rules-search-wrapper">
          <SearchInputComponent
            placeholder="Search by Rule name"
            onSearch={onSearch}
            ref={searchRef}
          />
        </div>
        <div className="lead-assignment-rules-list-filer-wrapper">
          <div className="lead-assignment-rules-list-refresh-icon" onClick={handleRefresh} tabIndex={0} title="Refresh">
            <RefreshIcon sx={{ color: "action.active" }} />
          </div>
          <Link
            to={routes.ARCHIVEDASSIGNMENTRULES}
            className="archive-icon-wrapper"
            tabIndex={0}
          >
            <Badge badgeContent={`${totalDeletedRules}+`} color="primary">
              <img
                src={ArchiveIcon}
                className="archive-icon"
                alt="Archive Icon"
              />
            </Badge>
          </Link>
          <div
            className="lead-assignment-rules-list-icon-filer"
            onClick={() => setIsOpenFilter(!isOpenFilter)}
            tabIndex={0}
          >
            <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge color="secondary" badgeContent={selectedLeadsFilter} sx={{
              '& .MuiBadge-badge': {
                backgroundColor: '#887952',
              },
            }}>
                <img src={FilterIcon} alt="Filter Icon" />
              </Badge>
            </Stack>
          </div>
          <div className="custom-btn-wrapper">
            {isSuperAdmin ? (
              <button className="custom-btn create-rule-btn">
                <Link to={routes.ASSIGNMENTRULESCREATERULE} className="link">
                  Create New Rule
                </Link>
              </button>
            ) : (
              <CustomTooltip title={(!isSuperAdmin && canWrite) ? 'Only AFP Super Admins can create rule' : ''}><button
                className="custom-btn create-rule-btn"
                disabled={!isSuperAdmin || !canWrite}
              >
                Create New Rule
                </button>
                </CustomTooltip>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadAssignmentRulesFilters;
